import React from 'react';
import styled from '@emotion/styled'

const FooterMain = styled.footer`
    width: 100%;
    text-align: right;
    height: 60px;
    background-color: #e1e1e1;
    color: darkgrey;
    box-shadow: 5px -2px 5px 1px #c1c1c1;
    position: fixed;
    left: 0;
    bottom: 0;

    div{
        padding-top: 1.5rem;
        margin-right: 30px;
        font-size: 1.7rem;

        a {
            text-decoration: none;
            color: black;
        }
    }
`;

const Footer = () => {
    return ( 
        <FooterMain>
            <div>
                © {new Date().getFullYear()}, Developed by 
                {` `}
                <a href="https://camilobuitracode.com" target="_blank" rel="noopener noreferrer">camilobuitracode </a>
                &copy;
            </div>
        </FooterMain>
     );
}
 
export default Footer;